import medications from '~/dummy-data/medications';
import {ApiResponse} from '~/utils/thunk-api/type';

const data: Record<string, any> = {
  ...medications,
};
export const requestDummyData = async (
  method: 'get' | 'post' | 'put' | 'delete',
  url: string,
): Promise<ApiResponse<any>> => {
  const [endpoint] = url.split('?');
  return {
    config: {},
    headers: {},
    request: undefined,
    status: 200,
    statusText: '',
    data: {data: data?.[endpoint]?.[method], message: '', status: '200'},
  };
};
